// H14 (Ticket 4b-2): timbre fuerte y repetido de la alerta de transferencia -- dos tonos alternados (tipo
// timbre clásico), ciclo de ~1 s, PARA sola cuando se llama a stop() (atender/rechazar/colgar/la transferencia
// desaparece). `getCtx` se inyecta para poder probar esto con un AudioContext simulado (sin navegador real).
export function createSiren(getCtx, { toneMs = 500, gain = 0.35, freqs = [880, 660] } = {}) {
  let timer = null;
  let ctx = null;
  let hi = true;

  const tone = (freq) => {
    if (!ctx) return;
    try {
      const g = ctx.createGain();
      const o = ctx.createOscillator();
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(gain, ctx.currentTime + 0.03);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + toneMs / 1000);
      o.connect(g); g.connect(ctx.destination);
      o.start(); o.stop(ctx.currentTime + toneMs / 1000);
    } catch (e) { /* audio no disponible: queda el aviso visual */ }
  };

  const beat = () => { tone(hi ? freqs[0] : freqs[1]); hi = !hi; };

  return {
    start() {
      if (timer) return; // ya sonando: no se duplica
      ctx = getCtx();
      if (!ctx) return;
      // El navegador exige un gesto previo para audio; si el contexto queda "suspended", se reintenta
      // (silencioso si falla) -- el aviso visual sigue sin depender de esto.
      if (ctx.state === "suspended" && typeof ctx.resume === "function") ctx.resume().catch(() => {});
      beat();
      timer = setInterval(beat, toneMs);
    },
    stop() {
      if (timer) { clearInterval(timer); timer = null; }
      try { ctx?.close?.(); } catch (e) { /* ya cerrado */ }
      ctx = null;
    },
    isRunning: () => !!timer,
  };
}
